module.exports = __webpack_public_path__ + "static/media/piece4.41e7f78b.png";